module.exports = __webpack_public_path__ + "img/68.b6118de0.png";